import { Heading } from "@freightsimple/ui-core/Typography/Heading";
import type { Shipment } from "@freightsimple/generated-dashboard-openapi-client/models/Shipment";

interface DeliveryNotesPageProp {
  shipment: Shipment;
}

export function ModifyShipmentDeliveryNotesPage(_props: DeliveryNotesPageProp) {
  return <Heading level={1}>Delivery Notes</Heading>;
}
